module.exports = __webpack_public_path__ + "img/IMG_9181-224_L_BlackMatted.c0485817.jpg";